import { Waitlist } from '@clerk/react';

/**
 * Sign-up page.
 *
 * The Clerk instance for WanEntry is in waitlist mode during closed beta —
 * new visitors join a waitlist rather than signing up directly. The Waitlist
 * component below collects emails for that list.
 *
 * Once the closed beta ends and Waitlist is disabled in the Clerk dashboard,
 * swap this for <SignUp /> from '@clerk/react'.
 */
export function SignUpPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12 dark:bg-slate-950">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">
            Join the WanEntry waitlist
          </h1>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
            We&apos;re in closed beta. Leave your email and we&apos;ll be in touch.
          </p>
        </div>
        <Waitlist
          signInUrl="/sign-in"
          appearance={{
            elements: {
              rootBox: 'mx-auto',
              card: 'shadow-md',
            },
          }}
        />
      </div>
    </div>
  );
}
